<template>
  <div class="footer">
    <b-navbar>
      <b-navbar-nav>
        <b-nav-item to="/" v-scroll-to="'#app'">Start</b-nav-item>
        <b-nav-item to="/" v-scroll-to="'#contact'">Kontakt</b-nav-item>
        <b-nav-item to="/" v-scroll-to="'#services'">Leistungen</b-nav-item>
        <b-nav-item to="/" v-scroll-to="'#projects'">Projekte</b-nav-item>
        <b-nav-item to="/" v-scroll-to="'#team'">Team</b-nav-item>
        <b-nav-item to="/" v-scroll-to="'#carrier'">Karriere</b-nav-item>
        <b-nav-item to="/impressum">Impressum</b-nav-item>
      </b-navbar-nav>
    </b-navbar>
    <div class="box">
      <div class="logo">
        <b-img src="../assets/images/logo.png"/>
      </div>
      <div class="copyright">Copyright 2021 by Die Gartenfee</div>
    </div>
    <div class="image">
      <b-img src="../assets/images/footer.png"/>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'Footer',
  }
</script>

<style lang="scss">
  @import '../assets/styles/footer.scss';
</style>
